import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import Page from "../../layout/Page";
//import Accion from "../../components/Accion";
import Modal from "../../components/Modal";
import api from "../../service/api";

const Ejemplo = (props) => {
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Ejemplo", ruta: "" },
  ];

  const [openModal, setOpenModal] = React.useState(false);
  const [pong, setPong] = React.useState("");

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handlePing = () => {
    api
      .ping()
      .then((res) => setPong(res.data))
      .catch((e) => setPong("Error"));
  };

  return (
    <Page title="Página de ejemplo" breadcrumbs={breadcrumbs}>
      <Typography variant="titulo" paragraph>
        Título
      </Typography>
      <Typography variant="cuerpo" paragraph>
        Cuerpo
      </Typography>
      <Typography variant="aclaracion" paragraph>
        Aclaraciones
      </Typography>
      <Button variant="verde" sx={{ m: 1 }}>
        VERDE
      </Button>
      <Button variant="gris" sx={{ m: 1 }}>
        GRIS
      </Button>
      <Button variant="azul" sx={{ m: 1 }}>
        AZUL
      </Button>
      <Button variant="plata" sx={{ m: 1 }}>
        PLATA
      </Button>
      <Button variant="amarillo" sx={{ m: 1 }}>
        AMARILLO
      </Button>
      <Button variant="naranja" sx={{ m: 1 }}>
        NARANJA
      </Button>
      <Button variant="verde" onClick={handleOpenModal} sx={{ m: 1 }}>
        Modal
      </Button>
      <Modal
        open={openModal}
        handleClose={handleCloseModal}
        title="Título Modal"
        responsiveTitle="Modal"
        closeButton
        size="md"
      >
        <p>Contenido del modal</p>
      </Modal>
      <br></br>
      <br></br>

      <Typography component={Box} variant="titulo">
        Conexión al backend
      </Typography>

      <Button variant="verde" sx={{ m: 1 }} onClick={handlePing}>
        Ping
      </Button>
      <Typography variant="cuerpo">{pong}</Typography>
    </Page>
  );
};

export default Ejemplo;
